import React, { ReactNode, FormEvent } from 'react';

import AuthFormRaw from './AuthFormRaw';
import AuthLayout from './AuthLayout';

type Props = {
  onSubmit?: (event: Event | FormEvent) => void;
  errorMessage?: string | null;
  heading?: string;
  subHeading?: ReactNode;
  children?: ReactNode;
  preChildren?: ReactNode;
  noMobileMenus?: boolean;
  mobileBackGoTo?: string;
};

export default function AuthForm({
  onSubmit,
  errorMessage,
  heading,
  subHeading,
  children,
  preChildren,
  noMobileMenus,
  mobileBackGoTo,
}: Props) {
  return (
    <AuthLayout
      heading={heading}
      subHeading={subHeading}
      noMobileMenus={noMobileMenus}
      mobileBackGoTo={mobileBackGoTo}
    >
      {preChildren}
      <AuthFormRaw onSubmit={onSubmit} errorMessage={errorMessage}>
        {children}
      </AuthFormRaw>
    </AuthLayout>
  );
}
